var ServiceClass = (function () {
    function ServiceClass() {
    }
    return ServiceClass;
}());
//# sourceMappingURL=ServiceClass.js.map